/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coverfitbefore2Inputs */

const en_coverfitbefore2 = /** @type {(inputs: Coverfitbefore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Now`)
};

const de_coverfitbefore2 = /** @type {(inputs: Coverfitbefore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jetzt`)
};

/**
* | output |
* | --- |
* | "Now" |
*
* @param {Coverfitbefore2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const coverfitbefore2 = /** @type {((inputs?: Coverfitbefore2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coverfitbefore2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coverfitbefore2(inputs)
	return de_coverfitbefore2(inputs)
});
export { coverfitbefore2 as "coverFitBefore" }